import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";

export interface BeoogoForm {
  isProduction: boolean;
  host: string;
  ssoHost: string;
  patientApi: string;
  patientUrl: string;
  ssoApi: string;
  clientId: string;
  clientSecret: string;
  userName: string;
  password: string;
}

@Component({
  selector: 'ms-form-beoogo',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './form-beoogo.component.html',
  styleUrl: './form-beoogo.component.scss'
})
export class FormBeoogoComponent implements OnInit {

  @Output() formChange = new EventEmitter<BeoogoForm>();
  @Output() validChange = new EventEmitter<boolean>();

  public form: BeoogoForm = {
    isProduction: true,
    host: 'https://api.beoogo.com',
    ssoHost: 'https://sso.beoogo.com',
    patientApi: '/legacy/v1/module/sync/patient',
    patientUrl: 'https://pro.beoogo.com',
    ssoApi: '/oauth/token',
    clientId: 'medispring-client',
    clientSecret: '',
    userName: '',
    password: '',
  };

  ngOnInit() {
    this.emitState();
  }

  public onFieldChange() {
    this.emitState();
  }

  private emitState() {
    this.formChange.emit({...this.form});
    this.validChange.emit(this.isValid());
  }

  private isValid(): boolean {
    const {isProduction, ...fields} = this.form;
    return Object.values(fields).every(v => v.trim().length > 0);
  }
}
